import { Injectable } from '@angular/core';
import { tokenNotExpired } from 'angular2-jwt';

import { environment } from "../../environments/environment";
import { Usuario } from './../usuario/usuario';

import { Headers, Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import 'rxjs/add/operator/toPromise';

import { URL_API, URL_CAS, URL_LOGOUT, HEADERS_GET } from './../constante';
//import { HEADERS } from './../constante';

import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class AuthAndACLService {
  jwtHelper: JwtHelper;

  //service = encodeURIComponent( API_HOSTNAME+'/jwt/login/?path='+href);
  constructor() {
    this.jwtHelper = new JwtHelper();
   //alert('constructor:'+localStorage.getItem('token_acesso'));
   }

  // This method will display the lock widget
  login(): void {
    let href = window.location.href;
    let origin = window.location.origin;

    //let service = encodeURIComponent( URL_API + 'token?path=' + href);
    //let service = encodeURIComponent('http://127.0.0.1:8000/login?path='+href);

    window.location.href = URL_API + '/login';

  }

  logado(): boolean {
	  return tokenNotExpired('token_acesso');
      //return true;
  }

  setUser(path:string ,token: string ): void {
    if (token !== undefined) {
      localStorage.setItem('token_acesso', token);
      window.location.href = path;
    } else {
      this.logout();
    }
  }

  logout(): void{
    localStorage.clear();
    let service = URL_API+'/logout/?path='+ URL_LOGOUT;
    window.location.href = service;
  }

  canAccess(accessRoles:string[]): boolean {
    //let usuario:Usuario = new Usuario();
    let usu:any = this.getUserData();
    let perfis:string[] = usu.perfis;
    let public_route:any = (accessRoles === undefined);

    if (public_route) {
      return true
    }
    //console.log("aqui " + usu.perfis);
    if (usu === undefined && usu.perfis === undefined) {
      return false;
    }

    //console.log("Regras de acesso " + accessRoles);

    let acesso = false;
    usu.perfis.forEach(perfil => {
      //console.log('perfill');
      //console.log(perfil);
      //console.log(perfil.nome);
      //console.log(perfil.pivot.usuario_id);
      //console.log(accessRoles.indexOf(perfil.nome));

      if (accessRoles.indexOf(perfil.nome) > -1) {
        //console.log('sim');
        //return true;
        acesso = true;
      }

    });

    //console.log("acesso = " + acesso);
    return acesso;

    /*for (var key in perfis){
      console.log("chave " + perfis[key]);
      if (accessRoles.indexOf(perfis[key]) > -1) {
        return true
      }
    }

    return false;*/

  }

  getUserData() {
      //console.log("Local storage = " + localStorage);
      var token = localStorage.getItem('token_acesso');

      // console.log(
      //   this.jwtHelper.decodeToken(token),
      //   this.jwtHelper.getTokenExpirationDate(token),
      //   this.jwtHelper.isTokenExpired(token)
      // );

      return this.jwtHelper.decodeToken(token);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth_and_acl/authAndACL.service.ts